import {LazyYoutubeVideos} from '../../../application/lazyLoad/lazyYoutubeVideos';
import {ReadyProvider} from '../../../application/providers/readyProvider';
import {VoteRating} from '../../../application/vote/voteRating';
import {CommentDeleteButtons} from '../../../application/comment/commentDeleteButtons';
import {ShopOffers} from './contents/shopOffers';
import {LazyOnlineConsultant} from '../../../application/lazyLoad/lazyOnlineConsultant';
import {ScrollTo} from '../../../application/scrollTo';
import {FormWithRating} from '../../../application/forms/formWithRating';
import 'default-passive-events';
import {ShopAnalytics} from './analytics/shopAnalytics';
import {ExternalProductClickManager} from "../externalProduct/externalProductClickManager";

ReadyProvider.executeOnReady(() => {
    let contentElement = document.querySelector('[data-shop="offers"]'),
        productsElement = document.querySelector('[data-block="external-products"]'),
        bannerCodeElement = document.querySelector('[data-content="banner-code"]');

    if (contentElement) {
        new ShopOffers(contentElement);
    }

    if (productsElement) {
        ExternalProductClickManager.init(productsElement);
    }

    if (bannerCodeElement) {
        bannerCodeElement.querySelector('[data-banner-code="shop"]').addEventListener('change', (event) => {
            bannerCodeElement.querySelector('[data-banner-code="button"]').setAttribute('data-param-shop_id', event.currentTarget.value);
        });
    }

    new VoteRating(document.querySelector('[data-vote="form"]'));
    new FormWithRating(document.querySelector('[data-comment="form"]'));
    new CommentDeleteButtons(document.querySelectorAll('[data-comment="delete"]'));
    ScrollTo.init();

    let analytics = new ShopAnalytics(),
        isAffiliatedMeta = document.querySelector('[data-shop="affiliated"]');

    analytics.sendPageViewEvent(isAffiliatedMeta.getAttribute('content') === '1');
    ReadyProvider.executeWithLazy(() => {
        LazyOnlineConsultant.load();
        LazyYoutubeVideos.load();
    });
});
